var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChartsIcn = function SvgChartsIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.48 4.08c1.94 2.19 3 5 3.02 7.93v.04c0 .43-.34.77-.77.77H15.45a.76.76 0 0 1-.77-.77V.77c0-.43.34-.77.77-.77 3.45 0 6.74 1.49 9.03 4.08zm-8.27-2.52v9.73h9.73a10.51 10.51 0 0 0-9.73-9.73zm-2.89 12.62h10.52c.42 0 .77.35.77.77a12.07 12.07 0 0 1-24.1 0C.49 8.3 5.9 2.9 12.54 2.9c.43 0 .77.34.77.76v10.52zm-11.29.77a10.53 10.53 0 0 0 21.02.77h-10.5a.76.76 0 0 1-.76-.77V4.45c-5.45.4-9.76 4.95-9.76 10.5z",
    fill: "#7388AE"
  })));
};
export default SvgChartsIcn;